import {connect} from 'react-redux';
import CreditHistoryStepView from '../../../components/views/mx/creditoReal/CreditHistoryStepView';
import * as WizardActions from '../../../actions/WizardActions';
import * as WizardMXActions from '../../../actions/WizardMXActions';
import {withRouter} from 'react-router';
import {COUNTRIES} from '../../../constants/AppConstants';
import {MX_VALUES} from '../../../constants/MX/WizardInputs';
import {pushDataLayer} from '../../../../common/utils/GTMUtils';
import {DATA_LAYER} from '../../../../common/constants/LabelConstants';

const mapStateToProps = (state, {match}) => {
    const creditHistory = state.creditoReal.loanApplication.creditHistory;
    return {
        bureauOption: creditHistory.bureauOption,
        bureauOptionCreditCardLastDigits: creditHistory.bureauOptionCreditCardLastDigits,
        bureauCatalogs: state.catalogs.bureauCatalogs,
        booleanOptions: MX_VALUES.BOOLEAN_VALUES,
        bureauOptionIdCreditCardLastDigits: COUNTRIES.MX.bureauOptionIdCreditCardLastDigits,
        skipNipValidation: state.creditoReal.loanApplication.nip.skip,
        country: state.countrySelector.countrySelected,
        loanApplicationToken: match.params.token
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        onPressNext: () => {
            pushDataLayer(DATA_LAYER.BUREAU_QUESTIONS);
            dispatch(WizardMXActions.SAVE_CREDIT_HISTORY_MX_ACTION.action());
        },
        onPressBack: () => dispatch(WizardMXActions.GO_TO_APPLICANT_DOMICILE_MX_ACTION.action()),
        onChangeBureauOptions: bureauOption => dispatch(WizardActions.CHANGE_CREDIT_HISTORY_OPTIONS_ACTION
            .action(bureauOption)),
        onChangeBureauOptionCreditCardLastDigits: bureauOptionCreditCardLastDigits => dispatch(WizardActions
            .CHANGE_BUREAU_OPTION_CREDIT_CARD_LAST_DIGITS_ACTION.action(bureauOptionCreditCardLastDigits)),
    };
};

const mergeProps = (stateProps, dispatchProps, ownProps) => {
    if (stateProps.bureauOption.length === 0) {
        stateProps.bureauOption =
            stateProps.bureauCatalogs.map(
                i => ({
                    id: i.id, value: i.value, booleanOptions: stateProps.booleanOptions.map(
                        item => ({
                            ...item
                        }))
                }));
    } else {
        stateProps.bureauOption = stateProps.bureauOption.map(i => ({
            id: i.id,
            value: i.value,
            payload: i.payload,
            booleanOptions: stateProps.booleanOptions.map(item => ({
                ...item,
                defaultChecked: item.payload === i.payload
            }))
        }));
    }
    return {
        ...stateProps,
        ...dispatchProps,
        ...ownProps
    };
};

const CreditHistoryStepContainer = withRouter<any, any>(connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
)(CreditHistoryStepView));

export default CreditHistoryStepContainer;